import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { progressiveLoading } from '../../../../../commons/styles/animations';
import NoPhoto from '../../../../../commons/components/icons/NoPhoto';
import mq from '../../../../../commons/styles/mediaQueries';

const BlockImage = styled.div`
  position: relative;
  margin-right: 16px;
`;

const BlockImageBadge = styled.div`
  position: absolute;
  bottom: 9px;
  right: 8px;
  ${({ isLoading }) => (isLoading ? progressiveLoading() : '')}
`;

const BlockImageContainer = styled.div`
  display: block;
  height: 90px;
  width: 130px;

  &:empty {
    ${progressiveLoading()}
  }

  ${({ image, theme }) =>
    image === null &&
    css`
      animation: none;
      background: ${theme.colors.bgSecondary};
    `}

  ${mq.desktop} {
    width: 170px;
    height: 114px;
  }
`;

const CenteredImage = styled.div`
  width: 100%;
  height: 100%;
  background-image: ${({ src }) => `url(${src})`};
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`;

const PhotoPlaceholder = styled(NoPhoto)`
  position: relative;
  margin-right: 16px;
  height: 100%;
  width: 100%;
`;

export default {
  BlockImage,
  BlockImageBadge,
  BlockImageContainer,
  CenteredImage,
  PhotoPlaceholder,
};
